export default class Loader {

	constructor(element) {
		this.handleTimeout = this.handleTimeout.bind(this);
		this.element = element;
		this.timeout = 500;
		this.loadingClass = 'gigs-loader--loading';
		this.timer = undefined;
	}

	show() {
		if (this.element instanceof HTMLElement) {
			this.element.classList.add(this.loadingClass);
		}
	}

	hide() {
		this.timer = window.setTimeout(this.handleTimeout, this.timeout);
	}

	handleTimeout() {
		if (this.element instanceof HTMLElement) {
			this.element.classList.remove(this.loadingClass);
		}
	}
}
